export const COMPONENT_NAMES = ["Entidades"]
